import { Texture } from "@/core/backends/webgl/texture"
import { RawDemosaicer, RawDemosaicerOptions } from "./raw-demosaicer"
import { Renderer } from "@/core/pipeline/renderer"
import { DualBuffers } from "@/core/pipeline/dual-buffers"
import { isSourceMonochromeRaw } from "../raw-info"

export class PassthroughDemosaicer extends RawDemosaicer {
	demosaicHalfSize(
		inputTexture: Texture,
		buffers: DualBuffers,
		renderer: Renderer,
		options: RawDemosaicerOptions,
	) {
		// Half size not supported for passthrough
		return this.demosaicFullSize(inputTexture, buffers, renderer, options)
	}

	demosaicFullSize(
		inputTexture: Texture,
		buffers: DualBuffers,
		renderer: Renderer,
		options: RawDemosaicerOptions,
	) {
		const { whiteBalanceMultipliers, levels } = options

		inputTexture.bind(0)
		buffers.writeBuffer.bindFramebuffer()

		renderer.backend.shaders.rawInt.render({
			source: 0,
			offset: options.globalOffset,
			isMono: isSourceMonochromeRaw(options.info),
			wbCoeffs: whiteBalanceMultipliers,
			blackLevel: levels[0],
			whitePoint: levels[1],
		})
	}
}
